<template>
    <div class="setup-mfa">
        <h2>You need to setup an MFA for your account</h2>

        <p>
            Administrator requires you to setup Multi-Factor Authentication (MFA) to your account.
            In order to setup an MFA you need to pick desired MFA option from dropdown below.
        </p>

        <div class="row">
            <div class="col-md-3">
                <div class="form-group required">
                    <label class="control-label">MFA type</label>
                    <select class="form-control" v-model="mfaType">
                        <option v-for="(type, id) in mfaTypes" :key="id" :value="id">{{ type }}</option>
                    </select>
                </div>
            </div>
        </div>

        <component
            v-if="mfaType"
            :is="mfaType"
            :is-loading="isLoading"
            :error-message="errorMessage"
            :type="mfaType"
            :phone-number="phoneNumber"
            @confirmed="handleConfirm"
        />
    </div>
</template>

<script>
import { onMounted, ref, watch } from "vue";

import { useLoading } from "@/hooks/use-loading";
import { getUserMfaData, resolveLoginAction } from "@/api/login";
import { mfaTypes, TYPE_MFA_SMS, TYPE_MFA_VOICE } from "@/pages/pending-actions/mfa-types";
import MfaAppSetupForm from "@/pages/common/MfaAppSetupForm.vue";
import MfaCodeSetupForm from "@/pages/common/MfaCodeSetupForm.vue";

export default {
    name: "ForceMfaSetup",
    components: {
        'app': MfaAppSetupForm,
        'sms': MfaCodeSetupForm,
        'voice': MfaCodeSetupForm,
    },
    setup(props, { emit }) {
        const { isLoading, startLoading, stopLoading } = useLoading(false);

        const mfaType = ref('');
        const phoneNumber = ref('');
        const errorMessage = ref('');

        const handleConfirm = async ({ code, type }) => {
            errorMessage.value = '';

            startLoading();
            try {
                await resolveLoginAction({
                    action: 'force_mfa_setup',
                    data: {
                        type,
                        code,
                    }
                });

                emit('action-handled');
            } catch (e) {
                errorMessage.value = e?.response?.data?.message ?? 'Unknown error';
                stopLoading();
            }
        };

        const loadUserMfaData = async () => {
            startLoading();

            try {
                const { result } = (await getUserMfaData()).data;

                mfaType.value = result.mfa_type;
                phoneNumber.value = result.phone_number;
            } catch (e) {
                console.error(e?.response?.data?.message);
            }

            stopLoading();
        }

        onMounted(() => loadUserMfaData());

        watch(
            () => mfaType.value,
            newValue => {
                if (newValue === TYPE_MFA_SMS || newValue === TYPE_MFA_VOICE) {
                    errorMessage.value = '';
                }
            }
        );

        return {
            isLoading,
            mfaTypes,
            mfaType,
            phoneNumber,
            errorMessage,
            handleConfirm,
        };
    }
}
</script>
